/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useContext, useEffect, useState } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { useLocation, withRouter } from 'react-router';
import {
    object, string, func, shape, array, bool, number, arrayOf,
} from 'prop-types';

// gql & helper functions
import { getContactId, getProfileInfo } from '../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getShopTheSite } from '../../../../../../pages/Account/utils/shopTheSite';
import {
    getIsProductFilterZipcodeValid, getSSRDeviceType, getSubscriptionFrequencyData, getWineData, getWineAgeVerified, getProductUnAvailable, getPageType,
} from '../../../../../../../state/ducks/App/App-Selectors';
import AddToCartErrorMessage from '../Partials/AddToCartErrorMessage/AddToCartErrorMessage';
import MaxCartErrorMessage from '../../../../../../pages/Checkout/containers/Common/MaxCartErrorMessage/MaxCartErrorMessage';
import { addToCartNewCartServices } from '../../../../../../../state/ducks/AddToCart/AddToCart-Actions';
import { getAddToCartError } from '../../../../../../../state/ducks/AddToCart/AddToCart-Selectors';
import { getPmallSummaryInfo } from '../../../../../../../state/ducks/Common/Common-Selectors';
import AddToCartBuilderObject from '../Partials/AddToCartBuilderObject';
import { CrossMerch } from '../../../../CrossMerchContainer/CrossMerchContainer';
import PersonalizationModal from '../../PersonalizationModal';
import AddonVerification from '../../CommonProductAgeZipVerify/CommonProductAgeZipVerify';
import useIsPlaPage from '../../../../../../helpers/hooks/useIsPlaPage';
import KlarnaCreditPromotionBadge from '../../../../../Checkout/KlarnaPaymentOnSiteMessage/KlarnaCreditPromotionBadge/KlarnaCreditPromotionBadge';
import { getFeatureFlag } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import useIsDisplayChannel from '../../../../../../helpers/hooks/useIsDisplayChannel';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import ProductStepperQuantity from '../../ProductStepperQuantity';
import TalonOneBanner from '../../TalonOne/talonOneBanner';
import LoadCardIslePDP from '../../../../../vendors/CardIsle/LoadCardIslePDP';

const styles = ({ palette, typography, breakpoints }) => ({
    buttonWrap: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        boxSizing: 'border-box',
        position: 'relative',
    },
    addToCartButton: {
        color: palette.white,
        fontFamily: typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '700',
        height: '50px',
        width: 'auto',
        minWidth: '350px',
        fontSize: '1em',
        textTransform: 'uppercase',
        borderRadius: '28px',
        lineHeight: '1.46em',
        marginTop: '15px',
        padding: '7px 24px 5px 24px',
        '&:disabled': {
            backgroundColor: `${palette.colorDisabled || '#ccc'}`,
            color: palette.white || '#fff',
        },
    },
    addToCartButtonV2: {
        width: 'auto',
        minWidth: '350px',
    },
    plaATC: {
        width: '100%',
        borderRadius: 0,
        minWidth: '100% !important',
    },
    addSubscriptionToCartButton: {
        color: palette.white,
        fontFamily: typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '600',
        width: 'auto',
        minWidth: '350px',
        height: '50px',
        fontSize: '1em',
        textTransform: 'uppercase',
        borderRadius: '28px',
        lineHeight: '1.46em',
        '&:disabled': {
            backgroundColor: `${palette.colorDisabled || '#ccc'}`,
            color: palette.white || '#fff',
        },
        // Mobile
        [breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    addSubscriptionToCartButtonV2: {
        width: 'auto',
        minWidth: '350px',
    },
    byoBtnWrapper: {
        '& $cyoAddToCartButton': {
            height: '50px',
            padding: '7px 24px 5px 24px',
            fontWeight: 'normal',
            fontSize: '1.1em',
            textTransform: 'uppercase',
            lineHeight: '1.46em',
            width: 'auto',
            minWidth: '447px',
            margin: '0 auto 15px auto',
        },
    },
    cyoAddToCartButton: {
        color: palette.white,
        fontFamily: typography.fontFamily,
        boxSizing: 'border-box',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        fontWeight: '700',
        width: '100%',
        height: '40px',
        fontSize: '1em',
        textTransform: 'uppercase',
        borderRadius: '4px',
        lineHeight: '1.46em',
        padding: '5px 24px 5px 24px',
        [breakpoints.down(959)]: {
            marginRight: '10px',
            fontSize: '14px !important',
            width: '-webkit-fill-available',
        },
    },
    addToCartBg: {
        backgroundColor: palette.primaryButton,
        [breakpoints.down(1080)]: {
            marginRight: '5px',
        },
    },
    addToCartBtn: {
        '& $addToCartButton , $addSubscriptionToCartButton': {
            borderRadius: '0px',
            minWidth: '447px',
            '&:hover': {
                backgroundColor: palette.primaryButton,
            },
            [breakpoints.down('md')]: {
                minWidth: '420px',
            },
            [breakpoints.down('sm')]: {
                minWidth: '100%',
            },
        },
    },
    disabledBtn: {
        textAlign: 'center',
        borderRadius: '0px',
        minWidth: '350px',
        width: 'auto',
        padding: '14px 24px 14px 24px',
        fontFamily: typography.fontFamily,
        fontSize: '1em',
        lineHeight: '1.46em',
        fontWeight: 'bold',
        marginTop: '15px',
    },
    fullDetail: {
        display: 'flex',
        color: palette.black || '#000000',
        width: '82%',
        justifyContent: 'flex-end',
        [breakpoints.down(1024)]: {
            width: '78%',
        },
        [breakpoints.down(850)]: {
            width: '74%',
        },
    },
    plaAddtoCart: {
        margin: '24px 0px 20px 0px',
    },
    inlineAddonCart: {
        borderRadius: 'inherit',
    },
    klarnaWidget: {
        paddingTop: '5px',
        display: 'flex',
        justifyContent: 'flex-end',
        marginRight: '-14px',
    },
    klarnaWidgetContainer: {
        display: 'flex',
        paddingTop: '5px',
        justifyContent: 'flex-end',
        [breakpoints.down('md')]: {
            marginRight: '5px',
        },
        [breakpoints.down('sm')]: {
            justifyContent: 'flex-start',
        },
    },

    shipmentMessage: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '18px',
        textTransform: 'capitalize',
        color: palette.upsellsTextColor || '#2F2F2F',
        marginBottom: '1px',
        textDecoration: 'none',
        marginTop: '16px',
        display: 'block',
    },

    shipmentMessageFuture: {
        fontWeight: '700',
        color: palette.upsellsFutureAvailabilityColor || '#A2011A',
        marginTop: '16px',
    },
    availabilityLeftAlign: {
        justifyContent: 'flex-start',
        '& $addToCartButtonV2': {
            marginBottom: '15px',
        },
        '& $addSubscriptionToCartButtonV2': {
            margin: '15px 0px',
        },
    },
    newPdpAddToCart: {
        padding: '0px',
        '& >#pwaAddToCartBtn, button': {
            borderRadius: '3px',
            height: '56px',
            fontSize: '18px',
            lineHeight: '26px',
            letterSpacing: '0.5px',
            textTransform: 'capitalize',
            width: '100%',
            padding: '0px',
            marginTop: '0px',
        },
    },
    shipmentWrapper: {
        fontSize: '16px',
        textAlign: 'left',
        marginTop: '0px',
        lineHeight: '20px',
        padding: '0px 0px 23px',
        color: '#2f2f2f',
        fontWeight: 500,
    },
    klarnaWrapper: {
        padding: '0px',
    },
    caDynamicPrice: {
        color: '#000',
        fontSize: 'var(--fontSizes-fontHeader5DT, 20px)',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: 'var(--lineHeights-lineHeader5DT, 25px)',
        letterSpacing: '0.2px',
        paddingBottom: '16px',
        display: 'flex',
        justifyContent: 'center',
        [breakpoints.down('600')]: {
            fontSize: 'var(--fontSizes-fontHeader6, 16px)',
            lineHeight: 'var(--lineHeights-lineHeader6, 21px)',
        },
    },
    deliveryMsg: {
        paddingLeft: '5px',
    },
    qtyAddtoCart: {
        minWidth: 'auto !important',
        marginBottom: '20px !important',
    },
});

const DesktopFoodAddToCart = ({
    classes,
    history,
    selectedItemId,
    brandId,
    actionAddToCart,
    partNumber,
    categoryId,
    subscription,
    subscriptionDetails,
    productType,
    totalProductSelected,
    maxComponents,
    cyoSelectedComponents,
    disableAddToCart,
    isPersonalizable,
    isAddToCartEnabled,
    wineValidation,
    categoryPath,
    categoryName,
    addons,
    closeAddonModal,
    handleMiniCartModalClick,
    contactId,
    quantity,
    addToCartError,
    isBandItemSelected,
    handleMobileAgeVerification,
    isPassportBundleProduct,
    hasWine,
    wineAgeVerified,
    movieSelected,
    productDemandType,
    deliveryMethod,
    isTryMeProduct,
    deliveryIndicatorPDP,
    pmallSummaryInfo,
    subscriptionValues,
    selectedSku,
    open,
    setOpen,
    closePersonalizationModal,
    setPersonalizationState,
    personalizedData,
    personalizationData,
    setPersonalization,
    handlePersonalizationTextFieldChange,
    zipValid,
    selectAddons,
    product,
    pdpInlineAddon,
    isBYOProduct,
    atcCallBack,
    content,
    isPdpRedesignEnabled,
    showAddToCart,
    cartIconLabel,
    isCaDelivery,
    addToCartPriceShow,
    isDeliverCharges,
    setProductQuantity,
}) => {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const { featureFlags = {} } = useContext(CrossMerch);
    const productUnAvailable = useSelector(getProductUnAvailable);
    const device = useSelector(getSSRDeviceType);
    const wineModelOnAction = featureFlags['is-inline-wine-verification-model-on-atc-enabled'] || false;
    const MINI_CART_ENABLED = featureFlags['is-mini-cart-enabled'];
    const AVAILABILITY_ATC_LEFT_ALIGNED = featureFlags['is-availability-atc-left-aligned'];
    const leftAlignClass = AVAILABILITY_ATC_LEFT_ALIGNED ? classes.availabilityLeftAlign : '';
    const cardIsleFlag = featureFlags['card-isle-product-type-control'];
    const cardIsleEnabled = !!cardIsleFlag?.[product?.availability?.productDeliveryType?.toLowerCase()];
    const isPmallPersonalizationAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'is_pmall_personalization_enabled');
    const isPmallPersonalizationEnabled = isPmallPersonalizationAttr?.values?.[0]?.value === 'true';
    const isPmallPersonalizationTypeAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'personalization_type_enabled');
    const pmallPersonalizationType = !!isPmallPersonalizationTypeAttr?.values?.[0]?.value;
    const isPmallCardIsleFlow = featureFlags['is-pmall-product-save-atc-enabled']
        && featureFlags['is-pmall-enabled']
        && (product?.brandId === '1030' || product?.brandId === '1033' || isPmallPersonalizationEnabled || pmallPersonalizationType)
        && selectedSku?.personalization?.personalizationAllowed;
    // Variables for Talon One
    const isTalonOneCreditWidgetEnabled = useSelector(getFeatureFlag('is-activation-talon-credit-widget-enabled'));
    const user = useSelector(getProfileInfo);
    const pageType = useSelector(getPageType);

    const enableMinicart = ((MINI_CART_ENABLED && device !== 'mobile') || featureFlags['is-mini-cart-v2-enabled']); // v2 will render on all device, v1 is not compatible with mobile
    const handleAddToCart = (productId = null, returnObject = false) => {
        const subscriptionData = {
            isSelected: subscription?.subscriptionCheckbox,
            hasFrequencyList: featureFlags['is-subscription-frequency'],
            hasDurationList: featureFlags['is-subscription-duration'],
            duration: subscriptionValues?.duration || subscriptionDetails?.subscriptionDurationKey,
            interval: subscriptionValues?.subscriptionInterval || subscriptionDetails?.subscriptionFrequency,
            type: subscriptionValues?.subscriptionType || subscriptionDetails?.subscriptionType,
        };

        // use same name that we need to pass to the attributeName in cart API call
        const attributes = {
            categoryId,
            categoryPath,
            categoryIdent: categoryName,
            demandTypeCode: productDemandType,
            tryMe: isTryMeProduct,
        };

        const wineVerify = {
            hasWine,
            wineValidation,
        };

        let personalizationLines;
        if (personalizationData.personalization?.lineState) {
            personalizationLines = personalizationData.personalization.lineState?.map((line, i) => ({
                perAttributeId: `${i + 1}`,
                perAttributeValue: personalizationData.personalization.lineState[i].lineText,
            }));
        }

        const personalizationValue = {
            isPersonalizable,
            personalizationData,
            personalizedData,
        };

        // GiftList - get Shop The Site content
        const giftList = getShopTheSite(contactId) || {};

        let productLineItemType = productType;
        // The products only needs firstname, lastname and email,
        // without send emails at the end of place order (example: market place vendor)
        if (
            selectedSku?.parentProduct?.categories?.includes('digital_delivery')
        ) {
            productLineItemType = 'DDELVR';
        }

        // The product when is NBCU
        if (
            selectedSku?.parentProduct?.categories?.includes('digital_products')
            || selectedSku?.name?.toLowerCase()?.includes('digital movie gift')
        ) {
            productLineItemType = 'NBCU';
        }

        const ATC = new AddToCartBuilderObject(
            brandId,
            (productId || selectedItemId),
            quantity,
            cyoSelectedComponents || [],
            addons || [],
            productLineItemType,
            subscriptionData,
            attributes,
            wineVerify,
            personalizationValue,
            pmallSummaryInfo,
            giftList,
            deliveryIndicatorPDP,
            deliveryMethod,
            contactId,
            selectedSku,
        );

        let passportBundle = {};
        if (isPassportBundleProduct?.enable) {
            passportBundle = {
                enable: true,
                passportSku: isPassportBundleProduct?.passportSku,
            };
        }

        const reqObj = ATC.getPayload();

        /**
             * Handle req object personlization fields
             * for internal products
             */
        if (personalizationLines) {
            reqObj.personalization = {
                personalizationType: 'PRODUCT_PERSONALIZATION',
                personalizationLines,
            };
        }

        if (returnObject) {
            return {
                reqObj,
                history,
                partNumber,
                categoryId,
                categoryName,
                enableMinicart,
                categoryPath,
                handleMiniCartModalClick,
                movieSelected,
            };
        }
        if (wineModelOnAction) {
            closeAddonModal();
        }

        if (atcCallBack && typeof atcCallBack === 'function') {
            atcCallBack(); // callBack
        }
        actionAddToCart({
            item: [reqObj],
            history,
            categoryId,
            partNumber,
            categoryName,
            categoryPath,
            enableMinicart,
            handleMiniCartModalClick,
            isMobile: false,
            eventType: 'Product Page',
            passportBundle,
            movieSelected,
        });
        return true;
    };
    let conditionalClasses;
    const isMonthOnlyPayFull = selectedSku?.subscriptions?.type === 'MonthOnlyPayFull' && featureFlags['disable-month-only-pay-full-pdp-subscription-banner'];
    const isSubscriptionChecked = (subscription?.subscriptionCheckbox && !isMonthOnlyPayFull) || false;
    const location = useLocation();
    const foodPlaRedesign = useSelector(getFeatureFlag('which-food-pla-design'));
    const isDisplayChannel = useIsDisplayChannel();

    const isPlaPage = useIsPlaPage() && featureFlags['is-simplified-pdp'] && foodPlaRedesign === 'variant';
    const isPlaNThreeColumn = (useIsPlaPage() || isDisplayChannel) && foodPlaRedesign === 'three_column';
    if (!disableAddToCart && !isSubscriptionChecked) {
        conditionalClasses = `${isPlaNThreeColumn ? classes.plaATC : ''} ${classes.addToCartButton} ${featureFlags['is-pdp-v-2-enabled'] && classes.addToCartButtonV2} ${classes.addToCartBg}`;
    } else if (!disableAddToCart && isSubscriptionChecked) {
        conditionalClasses = `${classes.addSubscriptionToCartButton} ${featureFlags['is-pdp-v-2-enabled'] && classes.addSubscriptionToCartButtonV2} ${classes.addToCartBg}`;
    } else {
        conditionalClasses = `${isPlaNThreeColumn ? classes.plaATC : ''} ${classes.addToCartButton} ${featureFlags['is-pdp-v-2-enabled'] && classes.addToCartButtonV2}`;
    }
    const getAvailabilityAddCart = () => {
        let availability = false;
        if (wineValidation) {
            const keys = Object.keys(wineValidation?.wineAvailability || {});
            keys.forEach((key) => {
                if (wineValidation?.wineAvailability[key].isProductAvailable && zipValid && wineAgeVerified) {
                    availability = true;
                }
            });
        }
        return availability;
    };

    const getPmallAddToCartEnabled = () => {
        let availability = false;
        const isPmallProduct = featureFlags['is-pmall-enabled'] && (brandId === '1030' || brandId === '1033');
        if (isPmallProduct && !pmallSummaryInfo?.customizations?.refnum && selectedSku?.personalization?.personalizationAllowed) {
            availability = true;
        }
        return availability;
    };

    const isAddToCartDisabled = (
        disableAddToCart
        || (!isAddToCartEnabled && !getAvailabilityAddCart() && !wineModelOnAction)
        || getPmallAddToCartEnabled()
    );
    const disableLayout = (
        <div className={`${classes.buttonWrap} ${isPdpRedesignEnabled ? classes.newPdpAddToCart : ''}`}>
            <Button
                id="pwaAddToCartBtn"
                className={classes.disabledBtn}
                variant="contained"
                disabled
            >
                OUT OF STOCK
            </Button>
        </div>
    );
    const selectedAddOnButton = `Add to ${cartIconLabel.toLowerCase()}`;
    const isShipNow = product?.availability?.deliveryMessage === 'AVAILABLE TO SHIP NOW';
    const hasPersonalization = featureFlags['is-personalization-pdp-enabled'] && selectedSku.personalization?.lines?.length > 0 && selectedSku.personalization?.indicator;
    const handleOpenPersonalizationModal = () => {
        setOpen(true);
    };
    const stepperQuantityEnabled = featureFlags['is-quantity-stepper-precheckout-enabled'] && !isTryMeProduct && quantity  && !useIsPlaPage() && !isDisplayChannel;
    // check for wineValidation is complete
    useEffect(() => {
        if (wineValidation?.ageValid && zipValid) {
            if (hasPersonalization) {
                handleOpenPersonalizationModal();
            }
        }
    }, [wineValidation?.ageValid, zipValid]);
    const inlineAddonClass = conditionalClasses;
    const availableToShipNowDisabled = product?.availability?.deliveryMessage !== 'AVAILABLE TO SHIP NOW' && !featureFlags['is-available-to-ship-now'];
    let layout = (
        <>
            {(availableToShipNowDisabled || featureFlags['is-available-to-ship-now']) && AVAILABILITY_ATC_LEFT_ALIGNED && !featureFlags['is-pdp-qty-availability-enabled'] ? <strong className={`${classes.shipmentMessage} ${isPdpRedesignEnabled ? classes.shipmentWrapper : ''} ${!isShipNow ? classes.shipmentMessageFuture : ''}`} availability="">{product?.availability?.deliveryMessage?.toLowerCase?.()}</strong> : ''}
            {isCaDelivery && addToCartPriceShow ? <div className={classes.caDynamicPrice}>${addToCartPriceShow}<span className={classes.deliveryMsg}> {isDeliverCharges ? 'with delivery fee' : 'plus shipping'}</span></div> : ''}
            {featureFlags['is-card-isle-pdp-add-on'] && cardIsleEnabled && showAddToCart && !isPmallCardIsleFlow && <LoadCardIslePDP />}
            <div className={`${classes.buttonWrap} ${isPdpRedesignEnabled ? classes.newPdpAddToCart : ''} ${leftAlignClass} ${featureFlags['ATC_button_PDP'] ? classes.addToCartBtn : ''}`} id="contAddToCartBtn">
                {stepperQuantityEnabled && <ProductStepperQuantity setProductQuantity={setProductQuantity} quantity={quantity} product={product} />}
                <Button
                    tabIndex="0"
                    id="pwaAddToCartBtn"
                    disabled={isAddToCartDisabled}
                    color="primary"
                    onClick={() => {
                        if ((pdpInlineAddon && !getAvailabilityAddCart() && hasWine) || (!getAvailabilityAddCart() && hasWine && wineModelOnAction)) {
                            setOpenModal(true);
                            handleMobileAgeVerification(true, hasPersonalization ? {} : handleAddToCart(null, true));
                            return;
                        }
                        if (hasPersonalization) {
                            // if the item requires personalization then pause the execution of this function and open
                            // personalization modal
                            setOpen(true);
                            return;
                        }
                        handleAddToCart();
                        if (enableMinicart) {
                            dispatch(trackEvent({
                                eventName: 'feature_interaction',
                                eventCategory: 'Product Page',
                                eventAction: 'Mini-Cart View',
                                eventLabel: `${selectedSku.name}`,
                            }));
                            closeAddonModal();
                        }
                    }}
                    className={`${isPlaPage ? `${classes.plaAddtoCart} ${conditionalClasses}` : inlineAddonClass} ${stepperQuantityEnabled ? classes.qtyAddtoCart : ''}`}
                    variant="contained"
                >
                    {isSubscriptionChecked ? `Add Subscription to ${cartIconLabel.toLowerCase()} $${addToCartPriceShow}` : selectedAddOnButton}
                </Button>
            </div>
            {isTalonOneCreditWidgetEnabled && <TalonOneBanner user={user} firstName={user?.firstName} pageType={pageType} />}
            {!isPlaPage && <div className={`${leftAlignClass} ${isPdpRedesignEnabled ? classes.klarnaWrapper : ''} ${featureFlags['ATC_button_PDP'] ? classes.klarnaWidgetContainer : classes.klarnaWidget}`}><KlarnaCreditPromotionBadge selectedSku={selectedSku} /></div>}
            {isPlaPage && <a className={classes.fullDetail}href={location?.pathname}>See Full Details</a>}
        </>
    );
    if (productType === 'cyo') {
        const disabledCYOAddToCart = totalProductSelected === 0 || (totalProductSelected !== maxComponents) || !isBandItemSelected;
        layout = (
            <>
                <div className={`${classes.buttonWrap} ${isBYOProduct ? classes.byoBtnWrapper : ''}`} id="contAddToCartBtn">
                    <Button
                        id="pwaAddToCartBtn"
                        onClick={() => {
                            if (!getAvailabilityAddCart() && hasWine) {
                                handleMobileAgeVerification(true, handleAddToCart(null, true));
                                return;
                            }
                            handleAddToCart();
                            if (enableMinicart) {
                                closeAddonModal();
                            }
                        }}
                        className={disabledCYOAddToCart ? classes.cyoAddToCartButton : `${classes.cyoAddToCartButton} ${classes.addToCartBg}`}
                        variant="contained"
                        disabled={disabledCYOAddToCart && !isBYOProduct}
                    >
                        {totalProductSelected !== 0 && totalProductSelected === maxComponents && ((isBandItemSelected && !isBYOProduct) || isBYOProduct)
                            ? `Add to ${cartIconLabel}`
                            : `Select ${!isBandItemSelected ? 'Band' : `${maxComponents} Items`}`}
                    </Button>
                </div>
                {isTalonOneCreditWidgetEnabled && <TalonOneBanner user={user} firstName={user?.firstName} pageType={pageType} />}
            </>
        );
    }

    // submit data Personalizationmodel data When click on countinue
    const handlePersonalizationModalSubmit = () => {
        const newPersonalizationState = { ...personalizationData, modalOpen: false };
        setPersonalization({
            personalization: newPersonalizationState,
        });
        if (Object.keys(personalizationData).length > 0) {
            setOpen(false);
            setOpenModal(false);
            handleAddToCart();
        }
    };
    const compileSelectedItems = () => {
        const selectedMonthSku = product?.club?.defaultSku?.components.find((item) => item?.month?.toLowerCase() === selectedSku?.date?.month?.toLowerCase());
        const productArray = [];
        productArray.push({
            brandCode: selectedSku?.brandId,
            productCode: selectedMonthSku?.partNumber,
            quantity: selectedSku?.quantity || 1,
            componentType: selectedSku?.productType,
        });
        return productArray;
    };
    const addonsSku = selectAddons?.find((addon) => addon.ageVerifyFlag === true || addon.ageVerifyFlag === 'true');
    return (
        <>
            {selectedSku.personalization?.lines
                && (
                    <PersonalizationModal
                        isOpen={open}
                        personalization={selectedSku.personalization}
                        setPersonalizationState={setPersonalizationState}
                        personalizationState={personalizationData.personalization}
                        handlePersonalizationTextFieldChange={handlePersonalizationTextFieldChange}
                        handlePersonalizationModalSubmit={handlePersonalizationModalSubmit}
                        closePersonalizationModal={closePersonalizationModal}
                        content={content}
                    />
                )}
            {openModal && (
                <AddonVerification
                    selectedSku={(Object.keys(addonsSku || {})?.length > 0 ? addonsSku : selectedSku) || {}}
                    productSkus={product?.productSkus}
                    isAddonAvailable
                    featureFlags={featureFlags}
                    classes={classes}
                    pdpInlineAddon={pdpInlineAddon || wineModelOnAction}
                    handleMobileAgeVerification={handleMobileAgeVerification}
                    open={openModal}
                    setOpen={setOpenModal}
                    handleAddToCart={handleAddToCart}
                    productBrand={product?.brand || null}
                    components={selectedSku?.productType === 'CLUB' ? compileSelectedItems() : []}
                    defaultSku={selectedSku?.productType === 'CLUB' ? product?.club?.defaultSku?.partNumber : selectedSku?.id}
                />
            )}
            {productUnAvailable ? disableLayout : layout}
            {addToCartError && <AddToCartErrorMessage error={addToCartError} />}
            <MaxCartErrorMessage cartIconLabel={cartIconLabel} />
        </>
    );
};

DesktopFoodAddToCart.propTypes = {
    classes: object.isRequired,
    history: object.isRequired,
    addToCartError: string,
    categoryId: string.isRequired,
    partNumber: string.isRequired,
    selectedItemId: string,
    brandId: string.isRequired,
    actionAddToCart: func.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
        subscriptionDurationKey: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
        subscriptionCheckbox: bool,
    }),
    productType: string,
    totalProductSelected: number,
    maxComponents: number,
    cyoSelectedComponents: array,
    disableAddToCart: bool,
    isPersonalizable: bool,
    wineValidation: shape({
        wineAvailability: object, // object type array
        wineVerify: shape({
            birthDay: 'string',
            birthMonth: 'string',
            birthYear: 'string',
            minAge: 'string',
        }),
    }),
    isAddToCartEnabled: bool.isRequired,
    categoryPath: string,
    categoryName: string,
    addons: arrayOf(shape({
        brandCode: string,
        productCode: number,
        componentType: string,
        productId: string,
        quantity: number,
    })),
    closeAddonModal: func,
    handleMiniCartModalClick: func,
    contactId: string,
    quantity: string,
    isBandItemSelected: bool.isRequired,
    handleMobileAgeVerification: func,
    hasWine: bool,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }),
    productDemandType: string,
    subscriptionValues: shape({
        duration: string,
        subscriptionType: string,
    }),
    deliveryMethod: string.isRequired,
    isTryMeProduct: bool,
    deliveryIndicatorPDP: string.isRequired,
    pmallSummaryInfo: shape({
        customizations: arrayOf(
            shape({
                refnum: string,
                description: string,
                'preview-url': string,
            }),
        ),
    }).isRequired,
    selectedSku: shape({
        id: string,
    }),
    open: bool.isRequired,
    setOpen: func.isRequired,
    closePersonalizationModal: func.isRequired,
    setPersonalizationState: func.isRequired,
    personalizationData: shape({
        personalization: shape({
            indicator: string,
            modalOpen: bool,
            lineState: arrayOf(
                shape({
                    lineText: string,
                    maxChars: number,
                }),
            ),
        }),
    }),
    personalizedData: shape({
        personalizationType: string,
        personalizationLines: arrayOf({
            perAttributeValue: string,
        }),
    }),
    setPersonalization: func.isRequired,
    handlePersonalizationTextFieldChange: func.isRequired,
    zipValid: bool,
    wineAgeVerified: bool.isRequired,
    selectAddons: array,
    product: array.isRequired,
    pdpInlineAddon: bool,
    isBYOProduct: bool,
    atcCallBack: func,
    content: object,
    isPdpRedesignEnabled: bool,
    showAddToCart: bool,
    cartIconLabel: string,
    addToCartPriceShow: object,
    isCaDelivery: bool,
    isDeliverCharges: bool,
    setProductQuantity: func,
};

DesktopFoodAddToCart.defaultProps = {
    selectedItemId: null,
    productType: '',
    totalProductSelected: 0,
    maxComponents: null,
    cyoSelectedComponents: [],
    subscriptionDetails: {},
    subscription: {},
    addToCartError: '',
    personalizationData: {},
    personalizedData: {},
    disableAddToCart: false,
    isPersonalizable: false,
    categoryPath: '',
    categoryName: '',
    addons: [],
    closeAddonModal: () => { },
    handleMiniCartModalClick: () => { },
    contactId: '',
    quantity: '1',
    wineValidation: null,
    handleMobileAgeVerification: () => { },
    hasWine: false,
    isPassportBundleProduct: {},
    movieSelected: null,
    productDemandType: null,
    isTryMeProduct: false,
    subscriptionValues: {},
    selectedSku: {},
    zipValid: null,
    selectAddons: [],
    pdpInlineAddon: false,
    isBYOProduct: false,
    atcCallBack: () => {},
    content: {},
    isPdpRedesignEnabled: false,
    showAddToCart: true,
    cartIconLabel: '',
    addToCartPriceShow: null,
    isCaDelivery: false,
    isDeliverCharges: false,
    setProductQuantity: () => {},
};

const mapStateToProps = (state) => ({
    contactId: getContactId(state),
    zipValid: getIsProductFilterZipcodeValid(state),
    wineValidation: getWineData(state),
    wineAgeVerified: getWineAgeVerified(state),
    addToCartError: getAddToCartError(state),
    pmallSummaryInfo: getPmallSummaryInfo(state),
    subscriptionValues: getSubscriptionFrequencyData(state),
});

const mapDispatchToProps = (dispatch) => ({
    actionAddToCart: bindActionCreators(addToCartNewCartServices, dispatch),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DesktopFoodAddToCart)),
);
